import { render } from "./StudentQuizCard.vue?vue&type=template&id=1888aae2"
import script from "./StudentQuizCard.vue?vue&type=script&lang=js"
export * from "./StudentQuizCard.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__